"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterSearchCriteriaByBrand = exports.isPopularDestination = exports.popularDestinations = exports.buildSelectedFilters = exports.gradeUnmapper = exports.bathroomUnmapper = exports.bedroomUnmapper = exports.bedroomMapper = exports.bathroomMapper = exports.PROPERTY_CALLOUT_BADGE_ID = exports.RESULTS_PAGE_SIZE = exports.NUM_OF_USP_TO_SHOW = exports.FUSION_DATE_FORMAT = exports.GRADE_CAT_IDS = void 0;
exports.getMinMaxRating = getMinMaxRating;
exports.GRADE_CAT_IDS = {
    gradetwo: 2,
    gradethree: 3,
    gradefour: 4,
    gradefive: 5,
};
exports.FUSION_DATE_FORMAT = 'dd-MM-yyyy';
exports.NUM_OF_USP_TO_SHOW = 3;
exports.RESULTS_PAGE_SIZE = 12;
exports.PROPERTY_CALLOUT_BADGE_ID = '10638';
function getMinMaxRating(rating) {
    const minMaxRating = rating.split('-');
    minMaxRating[1] =
        parseInt(minMaxRating[1], 10) > 4 ? '5' : `${minMaxRating[1]}.9`;
    return minMaxRating;
}
const bathroomMapper = (input) => {
    const bathroomCatIds = [
        'onebath',
        'twobath',
        'threebath',
        'fourbath',
        'fivebath',
        'sixplusbath',
    ];
    return bathroomCatIds.indexOf(input) + 1 || 1;
};
exports.bathroomMapper = bathroomMapper;
const bedroomMapper = (input) => {
    const bedroomCatIds = [
        'onebedexcludingstudio',
        'twobed',
        'threebed',
        'fourbed',
        'fivebed',
        'sixplusbed',
    ];
    return bedroomCatIds.indexOf(input) + 1 || 1;
};
exports.bedroomMapper = bedroomMapper;
const bedroomUnmapper = (input) => {
    const bedroomCategories = {
        onebedexcludingstudio: 1,
        twobed: 2,
        threebed: 3,
        fourbed: 4,
        fivebed: 5,
        sixplusbed: 6,
    };
    return bedroomCategories[input] || null;
};
exports.bedroomUnmapper = bedroomUnmapper;
const bathroomUnmapper = (input) => {
    const bathroomCategories = {
        onebath: 1,
        twobath: 2,
        threebath: 3,
        fourbath: 4,
        fivebath: 5,
        sixplusbath: 6,
    };
    return bathroomCategories[input] || null;
};
exports.bathroomUnmapper = bathroomUnmapper;
const gradeUnmapper = (grade) => {
    const REVERSED_GRADE_CAT_IDS = {
        2: 'gradetwo',
        3: 'gradethree',
        4: 'gradefour',
        5: 'gradefive',
    };
    return Object.keys(REVERSED_GRADE_CAT_IDS).find((key) => REVERSED_GRADE_CAT_IDS[key] === grade);
};
exports.gradeUnmapper = gradeUnmapper;
const buildSelectedFilters = (selectedFeatures, aggregationFeatures) => aggregationFeatures.filter(({ featureId }) => selectedFeatures?.includes(featureId));
exports.buildSelectedFilters = buildSelectedFilters;
exports.popularDestinations = new Set([
    9128, 9138, 9137, 9133, 10129, 9125, 9131, 10131, 9135, 9136, 10136, 10133,
    9782, 10094, 9134, 9129, 9132, 9124, 10095, 9127, 9126, 9123, 10134, 10137,
    10275, 10128, 9278, 9130, 10130, 9277, 10135, 10274, 9318, 10278, 10277,
    10132, 10096, 10276, 10279, 11789,
]);
const isPopularDestination = (id) => {
    const parsedId = Number(id);
    return exports.popularDestinations.has(parsedId);
};
exports.isPopularDestination = isPopularDestination;
const filterSearchCriteriaForNovasol = (searchCriteria) => {
    const { sref, regionId, ...novasolSearchCriteria } = searchCriteria;
    return {
        ...novasolSearchCriteria,
        ...(regionId && { locationTag: regionId }),
    };
};
const filterSearchCriteriaByBrand = (searchCriteria, brand) => {
    switch (brand) {
        case 'novasol':
        case 'fincallorca':
            return filterSearchCriteriaForNovasol(searchCriteria);
        default:
            return searchCriteria;
    }
};
exports.filterSearchCriteriaByBrand = filterSearchCriteriaByBrand;
//# sourceMappingURL=site-search-service.helper.js.map